import { Loading } from '../Loading'
import { LoadingCard, CardContent, LoadingText, IconWrapper, OverlayContainer, OverlayText } from './styles'

export const LoadingScreen = ({ variant = 'card', message = 'Cargando...' }) => {
  if (variant === 'overlay') {
    return (
      <OverlayContainer>
        <Loading size={64} />
        <OverlayText>{message}</OverlayText>
      </OverlayContainer>
    )
  }

  return (
    <LoadingCard>
      <CardContent>
        <IconWrapper>
          <Loading size={32} />
        </IconWrapper>
        <LoadingText>{message}</LoadingText>
      </CardContent>
    </LoadingCard>
  )
}
